export const APARTMENT_STATUS = {
  ROOT: '/apartmentStatus',
};
